import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const listingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: {
    listingStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent = {}, blockDesign = {} } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    listingClear: () => initialState,
    listingUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    listingUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    listingUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    listingUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { listingStore, listingClear, listingUpdateIsLoading, listingUpdateIsActive, listingUpdateBlockContent, listingUpdateBlockDesign } = listingSlice.actions;

export const selectListingIsLoading = (state) => state.listing.isLoading;
export const selectListingId = (state) => state.listing.id;
export const selectListingUID = (state) => state.listing.uid;
export const selectListingSID = (state) => state.listing.sid;
export const selectListingBlockContent = (state) => state.listing.blockContent;
export const selectListingBlockDesign = (state) => state.listing.blockDesign;
export const selectListingSortItems = createSelector([selectListingBlockContent], ({ items }) => items ?? []);
export const selectListingItemDesign = (state) => state.listing.itemDesign;
export const selectListingContainerDesign = (state) => state.listing.containerDesign;

export default listingSlice.reducer;
